<template>
  <div>
    <v-layout v-if="homePageAbout" wrap>
      <v-flex xs12>
        <v-card  min-height="470px" flat tile style="background-color: #FFFFFF">
          <v-layout justify-center pt-12 fill-height wrap>
            <v-flex xs10 lg12 md12>
              <!-- <v-img
                height="100bh"
                contain
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
                src="../../assets/images/aboutHome/map3.png"
                style="opacity: 1"
              > -->
              <v-layout pt-6 wrap justify-center>
                <v-flex v-if="homePageAbout.image" xs12  md10 lg10 text-center>
                  <v-img
                    height="70px"
                    contain
                    :src="baseURL+homePageAbout.image"
                  >
                  </v-img>
                  <span    style="
            font-family: poppinssemibold;
            color: #e7ab5f;
            font-size: 38px;
            leetter-spacing: 2px;
          ">
                    AL SADEEL ELECTROMECHANICAL WORKS
                  </span>
                </v-flex>
                <v-flex pt-3 xs12 md2 lg8 text-justify>
                  
                  <span
                    style="
                      font-family: poppinsregular;
                      font-size: 17px;
                      color: #000000 !important;

                      letter-spacing: 0px;
                    "
                  >
                    {{homePageAbout.text}}
                  </span>
                </v-flex>
              </v-layout>

              <!-- </v-img> -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      homePageAbout:{},
    };
  },
  mounted: function () {
    this.getAbout();
  },
  methods: {
    getAbout() {
      axios({
        method: "GET",
        url: "/homepage/view",
      })
        .then((response) => {
          if(response.data.status)
          this.homePageAbout = response.data.data.about;
        })
        .catch(() => {});
    },
  },
};
</script>